import { Injectable } from '@angular/core';
import {
  FormControl,
  AsyncValidatorFn,
  ValidationErrors,
} from '@angular/forms';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { INPUT_INFORMATIONS_API_CONSTANT } from '../constant/api-constant';
import { ValidatorService } from './validator.service';

@Injectable({
  providedIn: 'root',
})
export class Validator {
  constructor(private validatorService: ValidatorService) {}

  /**
   * 共通バリデーションチェック(カスタムバリデーター)
   * @param tblId テーブル名
   * @param colId カラム名
   * @param inputType 入力項目タイプ
   */
  public CheckValidator(
    tblId: string,
    colId: string,
    inputType: string
  ): AsyncValidatorFn {
    return (
      control: FormControl
    ):
      | Promise<ValidationErrors | null>
      | Observable<ValidationErrors | null> => {
      // 入力項目値を取得
      // const inputValue = control.value;
      let inputValue;
      if (INPUT_INFORMATIONS_API_CONSTANT.CHECKBOX_TYPE == inputType) {
        // チェックボックスの場合
        inputValue = control.value;
      } else if (typeof (control.value) == "object" && control.value) {
        // シングルセレクト、マルチセレクト、チェックボックスツリーの場合
        inputValue = control.value;
        // inputValue = control.value["value"];
      } else {
        // 上記以外
        inputValue = control.value;
        if (inputValue != null && inputValue.length > 1000) {
          return of({ 'invalidLength': true });
        }
      }

      // チェックAPIを呼び出し
      return this.validatorService
        .getValidatorResult(tblId, colId, inputValue)
        .pipe(
          map((response) => {
            /* 入力文字列の置換 */
            // 入力タイプを判定
            if (
              INPUT_INFORMATIONS_API_CONSTANT.TEXT_TYPE == inputType ||
              INPUT_INFORMATIONS_API_CONSTANT.NUMBER_TYPE == inputType ||
              INPUT_INFORMATIONS_API_CONSTANT.TEXTAREA_TYPE == inputType
            ) {
              // 入力タイプが'テキスト'or'数値'or'テキストエリア'の場合

              // 入力文字列と置換文字列が別々か否か
              if (inputValue != response.body[0].value) {
                // 入力文字列と置換文字列が別々の場合

                // 文字を置き換える
                control.setValue(response.body[0].value);
              }
            }

            // エラーメッセージ出力先格納変数
            let errors = new Object();

            // エラーメッセージが存在するか否か
            if (response.body[0].message) {
              // エラーメッセージが存在する場合

              // エラーメッセージ出力先格納変数にエラーメッセージを格納
              errors['message'] = response.body[0].message;
            }

            return errors;
          })
        );
    };
  }
}
